import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  radioOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    backgroundColor: PropTypes.string
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  labelStyle: PropTypes.string
}

const defaultProps = {
  className: '',
  labelStyle: ''
}

const RadioInputs = ({ className, selectedValue, radioOptions, onChange, labelStyle }) => {
  return (
    <S.RadioInputs className={className}>
      {
        _.map(radioOptions, ({ label, value, backgroundColor }) => {
          return (
            <S.RadioContainer key={value}>
              <S.Input value={value} type="radio" id={value} checked={value === selectedValue} {...{ onChange }} />
              <S.Label backgroundColor={backgroundColor} htmlFor={value} labelStyle={labelStyle}>{label}</S.Label>
            </S.RadioContainer>
          )
        })
      }
    </S.RadioInputs>
  )
}

RadioInputs.propTypes = propTypes
RadioInputs.defaultProps = defaultProps

export default RadioInputs

const S = {
  RadioInputs: styled.div`
    display: flex;
    flex-direction: row;
    column-gap: 15px;
  `,
  RadioContainer: styled.div`
    display: flex;
    align-items: center;
  `,
  Label: styled.label.withConfig({
    shouldForwardProp: (prop) => !['labelStyle', 'backgroundColor'].includes(prop)
  })`
    background-color: ${({ backgroundColor }) => backgroundColor};
    ${({ labelStyle }) => labelStyle}
    margin-left: 5px;
    cursor: pointer;
  `,
  Input: styled.input`
    cursor: pointer;
  `
}
